import { useState, useEffect } from 'react';
import { db } from '../../../config/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

export function useGiftsData() {
  const [giftLevelProducts, setGiftLevelProducts] = useState([]);
  const [giftItems, setGiftItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadGifts = async () => {
    setLoading(true);
    try {
      const productsCollection = collection(db, 'products');
      // Query for ALL products to find those with giftLevel OR GftItm in Categories
      const q = query(productsCollection);
      const snapshot = await getDocs(q);

      const giftLevelData = [];
      const giftItemData = [];

      snapshot.forEach(doc => {
        const data = doc.data();
        
        // First check: Products with giftLevel field ONLY (these are products that CAN have gifts added)
        const hasGiftLevel = data.giftLevel && Object.keys(data.giftLevel).length > 0;
        
        if (hasGiftLevel && data.isActive !== false) {
          const baseProduct = {
            id: doc.id,
            code: data.code || data.PLSSScode || doc.id,
            name: data.name || data.PrDescription || '',
            description: data.description || data.PrDescription || '',
            category: data.category || '',
            Categories: data.Categories || '',
            USP: data.USP || '',
            imageUrl: data.imageUrl || data.ImgLnk || '',
            prices: data.prices || { 
              USD: 0, 
              BHD: data.PrPriceBD || 0 
            },
            stock: data.stock || 0,
            PntPlsssCode: data.PntPlsssCode || '',
            isActive: data.isActive !== false
          };

          // Add to giftLevel products
          giftLevelData.push({
            ...baseProduct,
            giftLevel: data.giftLevel
          });
        }
        
        // Second check: Gift items MUST have Categories WITH GftItm
        const isGiftItem = data.Categories && data.Categories.includes('GftItm');
        
        if (isGiftItem && !hasGiftLevel && data.isActive !== false) {
          const baseProduct = {
            id: doc.id,
            code: data.code || data.PLSSScode || doc.id,
            name: data.name || data.PrDescription || '',
            description: data.description || data.PrDescription || '',
            category: data.category || '',
            Categories: data.Categories || '',
            USP: data.USP || '',
            imageUrl: data.imageUrl || data.ImgLnk || '',
            prices: data.prices || { 
              USD: 0, 
              BHD: data.PrPriceBD || 0 
            },
            stock: data.stock || 0,
            PntPlsssCode: data.PntPlsssCode || '',
            isActive: data.isActive !== false
          };

          // Add to gift items (actual gifts to be selected)
          giftItemData.push(baseProduct);
        }
      });

      setGiftLevelProducts(giftLevelData);
      setGiftItems(giftItemData);
    } catch (error) {
      console.error('Error loading gifts:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGifts();
  }, []);

  return {
    giftLevelProducts,
    giftItems,
    loading,
    error,
    loadGifts
  };
}
